export default "__VITE_ASSET__CUO1brr6__"